export const errorStatusToMessageMap: { [code: string]: string } = {
  NETWORK_ERROR: "errors.networkError",
  NO_WAITING_QUEUE_SLOT_AVAILABLE: "errors.noWaitingQueueSlotAvailable",
  INVALID_TREATMENT_TYPE: "errors.invalidTreatmentType",
  ERROR_CREATING_WAITING_QUEUE_SLOT: "errors.errorWarningAndTryAgain",
  ERROR_CREATING_CLIENT_ACCOUNT: "errors.errorWarningAndTryAgain",
};
